import React from "react";
import { Box, Modal, Typography } from "@mui/material";
import BuildIcon from "@mui/icons-material/Build";

interface MaintainceProps {
  isVisible: boolean;
  title?: string;
}

const Maintaince: React.FC<MaintainceProps> = ({ isVisible, title }) => (
  <Modal open={isVisible}>
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "90%",
        maxWidth: 420,
        bgcolor: "background.paper",
        borderRadius: 2,
        p: 4,
        textAlign: "center",
        outline: "none",
      }}
    >
      <BuildIcon sx={{ fontSize: 48, color: "text.secondary", mb: 2 }} />
      <Typography variant="h6" gutterBottom>
        {title || "Under Maintenance"}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        We&apos;ll be back shortly. Please try again in a few minutes.
      </Typography>
    </Box>
  </Modal>
);

export default Maintaince;
